export const TEAM_INVITE_FORM_ADD_NEW_ENTRY =
  "APP/TEAM_INVITE_FORM/ADD_NEW_ENTRY";
export const TEAM_INVITE_FORM_REMOVE_ENTRY =
  "APP/TEAM_INVITE_FORM/REMOVE_ENTRY";
export const TEAM_INVITE_FORM_RESET = "APP/TEAM_INVITE_FORM/RESET";
